<!-- App.vue -->
<template>
    <div v-show="scanning" class="scanner-container fixed top-0 left-0 right-0 bottom-0 " style="z-index: 9999;">
        <div class="text-white absolute top-0 left-0 p-4 flex items-center z-[333]" @click="stopScanning">
            <ArrowLeft class="w-[20px]"></ArrowLeft>
            返回
        </div>
        <video ref="videoElement" class="w-full h-full object-cover"></video>

        <div class="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
            <div class="text-center text-white">对准二维码到框内扫描即可</div>
            <div class="scan-border border-2 border-white-500 w-64 h-64"></div>

            <el-button @click="stopScanning" size="large" class="mt-10 w-full" type="primary">返回</el-button>

            <div
                class="w-full h-12 bg-gradient-to-b from-transparent to-blue-500 top-6 absolute animate-[bounce-long_3s_infinite]">
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import jsQR from 'jsqr'
import { ArrowLeft } from '@element-plus/icons-vue';

const scanning = ref(false)
const scanResult = ref(null)
const videoElement = ref<HTMLVideoElement | null>(null)
const emit = defineEmits(['stop', 'success'])
let stream = null
let scanInterval = null

const startScanning = async () => {
    try {
        stream = await navigator.mediaDevices.getUserMedia({
            video: {
                facingMode: 'environment' // 优先使用后置摄像头
            }
        })

        if (videoElement.value) {
            videoElement.value.srcObject = stream
            videoElement.value.play()
            scanning.value = true

            // 开始扫描
            scanInterval = setInterval(processFrame, 500)
        }
    } catch (error) {
        ElMessage.error('无法访问摄像头：' + error.message)
    }
}

const processFrame = () => {
    if (!videoElement.value) return

    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')

    canvas.width = videoElement.value.videoWidth
    canvas.height = videoElement.value.videoHeight

    context.drawImage(videoElement.value, 0, 0, canvas.width, canvas.height)

    const imageData = context.getImageData(0, 0, canvas.width, canvas.height)
    const code = jsQR(imageData.data, imageData.width, imageData.height, {
        inversionAttempts: 'dontInvert'
    })

    if (code) {
        handleQRCodeResult(code.data)
    }
}

const handleQRCodeResult = (result) => {
    // 停止扫描
    stopScanning()

    // 处理扫描结果
    scanResult.value = result
    emit('success', scanResult.value)
    ElMessage.success('扫描成功：' + result)
}

const stopScanning = () => {
    if (scanInterval) {
        clearInterval(scanInterval)
    }

    if (stream) {
        stream.getTracks().forEach(track => track.stop())
    }

    scanning.value = false
    console.log(1);
    emit('stop')
}

// 组件卸载时清理资源
onUnmounted(() => {
    stopScanning()
})
defineExpose({
    startScanning
})
</script>

<style scoped>
.scanner-container {
    position: relative;
    overflow: hidden;
}



@keyframes scan-animation {

    0%,
    100% {
        border-color: rgba(34, 197, 94, 0.5);
    }

    50% {
        border-color: rgba(34, 197, 94, 1);
    }
}
</style>